// Plain utilities — safe to import in Nitro server routes too

// `discoverType` wins over the layout `type` (e.g. template-four + discoverType
// "supplier" is a supplier site). Keep in sync with middleware/redirects.global.ts.
export const isSupplierLayout = (
  layout?: { type?: string; discoverType?: string } | null
): boolean => {
  if (layout?.discoverType) return layout.discoverType === 'supplier'
  return (layout?.type ?? '').includes('supplier')
}

export const buildProductPath = (slug: string, citySlug: string, isSupplier: boolean = false): string => {
  if (isSupplier) return `/experiences/${slug}`
  return `/things-to-do-in-${citySlug}/${slug}`
}

export const buildCityPath = (citySlug: string, isSupplier: boolean = false): string => {
  if (isSupplier) return `/experiences?city=${citySlug}`
  return `/things-to-do-in-${citySlug}`
}

export const buildCategoryPath = (slug: string): string => {
  return `/${slug.replace(/^\/+/, '')}`
}

export const getLocaleSlug = (
  slugs: Record<string, string>,
  locale: string = 'en',
  fallbackLocale: string = 'en'
): string => {
  const res =  slugs[locale] ?? slugs[fallbackLocale] ?? Object.values(slugs)[0] ?? ''
  console.log(slugs, locale, fallbackLocale, res)
  return res
}

// Vue composable — wraps the above with useLocalePath
export const usePath = () => {
  const config = useRuntimeConfig()
  const localePath = useLocalePath()
  const isSupplier = isSupplierLayout(config.public.layout as { type?: string; discoverType?: string })
  const locale = useI18n().locale.value
  const defaultLocale = useI18n().defaultLocale

  return {
    productPath: (slug: string | Record<string, string>, citySlug: string) => {
      const localeSlug = typeof slug === 'string' ? slug : getLocaleSlug(slug, locale, defaultLocale)
      return localePath(buildProductPath(localeSlug, citySlug, isSupplier))
    },
    cityPath: (citySlug: string) =>
      localePath(buildCityPath(citySlug, isSupplier)),
    categoryPath: (slug: string) => localePath(buildCategoryPath(slug)),
  }
}
